import React from 'react';
import { Send, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#11111f] text-gray-400 py-16 border-t border-gray-800" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-58">
          {/* Brand */}
          <div data-id="element-59">
            <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-60">
              新加坡幸福缘
            </h3>
            <p className="text-sm leading-relaxed mb-6" data-id="element-61">
              Singapore Happiness Connection
              <br data-id="element-62" />
              新加坡幸福缘是新加坡领先的专业按摩与伴游服务平台，提供精油按摩、泰式按摩、深层组织按摩、足部按摩及高端伴游等全方位服务。我们拥有20余位经验丰富的专业技师，24小时全天候为您服务，致力于为每一位客户带来最优质的身心放松体验。
            </p>
            <div className="flex space-x-4" data-id="element-63">
              <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors flex items-center gap-2" data-id="element-64">
                <Send size={18} data-id="element-65" />
                <span className="text-sm" data-id="element-66">Telegram</span>
              </a>
              <a href="https://www.geylang777-5.site" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors flex items-center gap-2" data-id="element-67">
                <Globe size={18} data-id="element-68" />
                <span className="text-sm" data-id="element-69">官网</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-70">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-71">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-72">
              <li data-id="element-73">
                <a href="#hero" className="hover:text-[#c9a96e] transition-colors" data-id="element-74">
                  首页 (Home)
                </a>
              </li>
              <li data-id="element-75">
                <a href="#services" className="hover:text-[#c9a96e] transition-colors" data-id="element-76">
                  服务 (Services)
                </a>
              </li>
              <li data-id="element-77">
                <a href="#therapists" className="hover:text-[#c9a96e] transition-colors" data-id="element-78">
                  技师 (Therapists)
                </a>
              </li>
              <li data-id="element-79">
                <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-80">
                  预约 (Book Now)
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-81">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-82">
              Service Hours
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-83">
              <li className="flex justify-between" data-id="element-84">
                <span data-id="element-85">Monday - Sunday</span>
                <span className="text-white" data-id="element-86">24 Hours</span>
              </li>
              <li className="mt-4 text-xs text-gray-500" data-id="element-87">
                * Public holidays open as usual
              </li>
            </ul>
          </div>
        </div>

        {/* 友站链接 */}
        <div className="mb-12" data-id="element-88">
          <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-89">
            友站链接
          </h4>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm" data-id="element-90">
            <a href="https://ttvip-64.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-91">
              ttvip-64.com
            </a>
            <a href="https://shiok27.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-92">
              shiok27.com
            </a>
            <a href="https://xfy01.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-93">
              xfy01.net
            </a>
            <a href="https://sgharem6.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-94">
              sgharem6.net
            </a>
            <a href="https://qc52.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-95">
              qc52.me
            </a>
            <a href="https://sglonelyguy.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-96">
              sglonelyguy.me
            </a>
            <a href="https://ttvip.life/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-97">
              ttvip.life
            </a>
            <a href="https://locanto.space/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-98">
              locanto.space
            </a>
            <a href="https://kkbaby.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-99">
              kkbaby.site
            </a>
            <a href="https://xfy8.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-100">
              xfy8.com
            </a>
            <a href="https://sgbeautycastle.live/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-101">
              sgbeautycastle.live
            </a>
            <a href="https://shiok26.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-102">
              shiok26.site
            </a>
            <a href="https://sgharem.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-103">
              sgharem.site
            </a>
            <a href="https://shiok8.xyz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-104">
              shiok8.xyz
            </a>
            <a href="https://geylang777.info/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-105">
              geylang777.info
            </a>
            <a href="https://ttvip-62.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-106">
              ttvip-62.site
            </a>
            <a href="https://geylang666.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-107">
              geylang666.me
            </a>
            <a href="https://isyou.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-108">
              isyou.net
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-109">
          <p data-id="element-110">
            &copy; {new Date().getFullYear()} Singapore Happiness Connection.
            All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-111">
            <a href="#" className="hover:text-gray-400" data-id="element-112">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-113">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}